import { useEffect, useState } from 'react'
import { vraag } from './lib/api'
import { zetManifest } from './lib/installeren'
import { ga, usePad } from './lib/router'
import type { Openbaar } from './lib/typen'
import { Beheer } from './beheer/Beheer'
import { Afmelden } from './klant/Afmelden'
import { Klant } from './klant/Klant'
import { Tablet } from './tablet/Tablet'

/*
 * Toegang per adres (docs/toegang.md):
 *   /                 klantdashboard
 *   /beheer...        beheer (eigen inlog)
 *   /<slug>           locatie-tablet
 *   /<onbekend>       klantdashboard (spec/rules.json: toegang.onbekendeSlug)
 */
export function App() {
  const pad = usePad()
  const [data, zet] = useState<Openbaar | null>(null)
  const [fout, zetFout] = useState(false)

  useEffect(() => {
    let weg = false
    const laad = () => vraag<Openbaar>('vestigingen').then((d) => { if (!weg) { zet(d); zetFout(false) } }, () => { if (!weg) zetFout(true) })
    laad()
    const t = setInterval(laad, 10 * 60_000)
    return () => { weg = true; clearInterval(t) }
  }, [])

  const eerste = pad.split('/')[1]?.toLowerCase() ?? ''
  useEffect(() => { zetManifest(pad) }, [pad])
  useEffect(() => {
    if (eerste && eerste !== 'beheer' && eerste !== 'afmelden' && data && !data.vestigingen.some((v) => v.slug === eerste)) ga('/', true)
  }, [eerste, data])

  if (eerste === 'beheer') return <Beheer pad={pad} />
  if (eerste === 'afmelden') return <Afmelden token={pad.split('/')[2] ?? ''} />
  if (eerste) {
    if (!data) return fout ? <Klant data={null} /> : <div className="kiosk" />
    if (data.vestigingen.some((v) => v.slug === eerste)) return <Tablet slug={eerste} data={data} />
  }
  return <Klant data={data} />
}
